import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core'
import { useHistory } from "react-router-dom";
import Chip from '@material-ui/core/Chip';

import { Coin } from '../shared/component'
import useStyles from '../../styles/components/survey/stylesSurvey'
import ChallengeContext from '../../context/challenge-context'

const CloseChallengeHolder = () => {
    const classes = useStyles();
    const history = useHistory();
    const { challengeContext } = useContext(ChallengeContext);
    const [rowsPerPage, setRowsPerPage] = React.useState(4);

    const onLoadMore = () => setRowsPerPage(rowsPerPage + 4)

    const handleClickOpen = (id) => {
        return history.push(`/ChallengeDetail/${id}`);
    }

    return (
        <>
            {
                challengeContext.closeChallenges.length > 0 ?
                    challengeContext.closeChallenges.slice(0, rowsPerPage).map((challenge) => (
                        <Accordion defaultExpanded
                            key={challenge.ChallengeId}
                            classes={{
                                root: clsx(classes.rootAccordion, classes.active),
                                expanded: classes.expandedAccordion,
                                rounded: classes.roundedAccordion,
                            }}
                        >
                            <AccordionSummary
                                classes={{
                                    root: classes.rootAccordionSummaryForChallenge,
                                    content: classes.contentAccordionSummary,
                                    expanded: classes.expandedAccordionSummary,
                                }}
                            >
                                <Grid
                                    item xs={12}
                                    container
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridContent }}
                                >
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textTitle)}> {challenge.ChallengeTitle} </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textDescription)}>
                                            Challenge ended on {challenge.EndDate}
                                            {`  `}
                                            {
                                                !challenge.IsSignedUp ?
                                                    <Chip style={{ backgroundColor: '#ff5768', color: 'white' }}
                                                        label={`Missed`}
                                                    />
                                                    :
                                                    <Chip style={{ backgroundColor: '#4DD091', color: 'white' }}
                                                        label={`Participated`}
                                                    />
                                            }
                                        </div>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        classes={{ root: classes.containerProrgessBar }}
                                    >
                                        <Grid item xs={12} classes={{ root: classes.wrapperProrgessBarCoin }}>
                                            <div className={clsx(classes.rootCoin)}>
                                                <Coin
                                                    coin={challenge.RewardCoins}
                                                    size="medium" />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography color="secondary">
                                    Click <a className="button one" onClick={() => handleClickOpen(challenge.ChallengeId)}>Here</a> to see the progress.
                         </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))
                    : <></>
            }
            {
                rowsPerPage < challengeContext.closeChallenges.length &&
                <Grid classes={{ root: classes.containerLoadmore }} container justify="center" alignItems="center" onClick={() => onLoadMore()}>
                    <div>
                        Load more
                     </div>
                </Grid>
            }
        </>
    );
};

export { CloseChallengeHolder as default }
